<div class="tabela-skeleton">
  @for (item of linhas; track item){
    <div class="tabela-item-skeleton"></div>
  }
</div>
